export default __webpack_public_path__ + "static/media/hero_video.beed3248.mp4";